module.exports = __webpack_public_path__ + "static/img/certificate_img24.9812deb3.jpg";